<div class="bpaas-error">
  <div class="card">
    <div class="flex flex-column align-items-center justify-content-center card-container h-screen">
        <div class="bpaas-exception-title mb-3">ERROR</div>
        <div class="bpaas-exception-detail mb-7">Something went wrong.</div>
        <div class="bpaas-exception-detail mb-3">
          <button pButton pRipple btnback type="button" class="p-button-warning">
            Back to Dashborad
          </button>
        </div>
    </div>
  </div>
</div>
